@if (isLoader || status === CHANNEL_STATUS.PROCESSING) {
  <app-sidebar-header (close)="close.emit()" [title]="('integration' | translate) + ' Viber'"></app-sidebar-header>
  <div class="viber-loader-container">
    @if (isConnectionProcessed) {
      <p>{{ 'viber_connection_description' | translate }}</p>
    }
    <app-loader size="big"></app-loader>
  </div>
} @else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}

<ng-template #content>
  <div class="h-100 overflow-auto crm-scroll viber-integration-container">
    <app-sidebar-header (close)="close.emit()" [title]="('integration' | translate) + ' Viber'" />
    <mat-card class="shadow-none bg-transparent">
      <mat-card-content class="d-flex flex-column bg-white rounded-2 m-3 p-4">
        <div class="header-container">
          <div class="icon-logo">
            <img src="/assets/svgs/integrations/viber.svg" alt="Viber logo" />
          </div>
          <div class="copy-ID">
            <h5 class="viber-integration-description">{{ 'log_in_with_your_viber_account' | translate }}</h5>
            <div class="container-copy">
              <app-button (onChangeClick)="copyChannelId()">
                {{ 'copy_channel_ID' | translate }}
              </app-button>
            </div>
          </div>
        </div>

        <div class="pt-3">
          <p>{{ 'channel' | translate }}: {{ channel_name }}</p>
          <p>
            {{ 'status' | translate }}:
            @if (CHANNEL_STATUS_OBJECT[status]) {
              <span class="badge" [ngStyle]="{ 'background-color': CHANNEL_STATUS_OBJECT[status].color }">
                {{ 'channel_status_new.' + CHANNEL_STATUS_OBJECT[status].textKey | translate }}
              </span>
            }
          </p>
          <div class="d-flex gap-2 flex-wrap flex-column justify-content-center">
            @switch (status) {
              @case (CHANNEL_STATUS.CONNECTED) {
                <app-button class="d-flex justify-content-center" btnType="stroked" (onChangeClick)="deleteChannel()"
                  >{{ 'delete' | translate }}
                </app-button>
                @if (isAdmin) {
                  <app-button class="flex justify-center" btnType="stroked" (onChangeClick)="restartViber()"
                    >{{ 'restart' | translate }}
                  </app-button>
                  @if (vncUrl) {
                    <a
                      [href]="vncUrl"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="text-center text-blue-600 underline hover:text-blue-800"
                    >
                      {{ 'open_ui' | translate }}
                    </a>
                  }
                }
              }
              @default {
                @if (!showQr) {
                  <app-input
                    labelType="floating"
                    [variant]="'on'"
                    [inputType]="'phone'"
                    [formControl]="phoneControl"
                    [id]="'phone'"
                    [invalid]="phoneControl.touched && phoneControl.invalid"
                    [required]="true"
                    [options]="PHONES_FOR_INPUT"
                    [optionValue]="'value'"
                    [optionLabel]="'title'"
                    [readonly]="!!phoneNumber"
                    [disabled]="isPhoneInputDisabled"
                  />
                  <app-button class="d-flex justify-content-center" (onChangeClick)="createQrCode()"
                    >{{ 'connect' | translate }}
                  </app-button>
                }
              }
            }
            <mat-checkbox
              [checked]="isHandleFiles"
              [disabled]="status === CHANNEL_STATUS.CONNECTED"
              (change)="isHandleFilesChanged($event)"
            >
              {{ 'handle_files' | translate }}
            </mat-checkbox>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    @if (showQr) {
      <mat-card class="shadow-none bg-transparent">
        <mat-card-content class="d-flex flex-column bg-white rounded-2 m-3 p-4">
          <div class="qr-code-container">
            <p class="qr-code-description">{{ 'scan_qr_for_viber' | translate }}</p>
            <p class="qr-code-additional-description">
              {{ 'scan_qr_for_viber_additional_description' | translate }}
            </p>
            <div #qrcode></div>
          </div>
        </mat-card-content>
      </mat-card>
    }

    @if (phoneNumber) {
      <mat-card-content class="d-flex flex-column bg-white rounded-2 m-3 p-4">
        <h5>{{ 'information' | translate }}</h5>
        <mat-divider class="mb-3"></mat-divider>
        <p class="text-secondary">
          {{ 'phone_number' | translate }}: <span class="text-dark">{{ phoneNumber }}</span>
        </p>
      </mat-card-content>
    }

    <app-integration-review
      [youtubeReviewLink]="'https://www.youtube.com/watch?v=MoIdWmpvyKs'"
    ></app-integration-review>
  </div>
</ng-template>
